export class CreateProjectInput {
    'name';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateProjectInput.attributeTypeMap;
    }
    constructor() {
    }
}
